import { STORAGE_KEYS } from "@/constants/storage";

export const sessionStore = {
  hasAccessToken: () => !!sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
  getAccessToken: () => sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
};
